import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, UrlTree, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { fillReturnOrderAction, loadOrderDataAction } from "../../store/actions/order.actions";
import { clientConfig } from "../constant/app.constant";
import { CopyHelpers } from "../helpers/copy.helpers";
import { AppFlowService } from "../services/app-flow/app-flow.service";
import { ReturnOrderService } from "../services/return-order/return-order.service";
import { SpinnerService } from "../services/spinner.service";

@Injectable({
  providedIn: "root",
})
export class EditShipmentRouteGuard  {
  constructor(
    private router: Router,
    private store: Store<AppState>,
    private appFlowService: AppFlowService,
    private returnOrderService: ReturnOrderService,
    private spinnerService: SpinnerService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentPath = next.routeConfig.path;
    console.log("current :>> ", currentPath);

    const appFlow = this.appFlowService.getActiveAppFlow();
    const parent = next.parent.routeConfig.path;
    const current = appFlow.sequence.find((s) => s.path === next.routeConfig.path);

    this.spinnerService.show();

    return this.returnOrderService.getShipment().pipe(
      map((res: any) => {
        this.spinnerService.hide();
        if (res.success) {
          const order = res.order;
          if (!this.validateOrder(order)) {
            console.log("missingRequiredOrderInfo... ");
            return false;
          }

          this.store.dispatch(loadOrderDataAction({ payload: { ...order, isValid: true } }));

          const ord = CopyHelpers.deepCopy(order);
          if (ord.orders && ord.orders.length) {
            this.store.dispatch(
              fillReturnOrderAction({
                payload: { order: ord.orders[0] },
              })
            );
          }

          if (order.hasCarrierCancelled && order.hasCarrierCancelled.toLowerCase() === "true") {
            return this.router.parseUrl(`${parent}/${current.next}`);
          }
          return true;
        }

        if (res.error) console.error(res.error);
        const error = {
          title: "",
          message: "missingLoginOrder",
          translationParams: { merchantName: clientConfig.TITLE },
        };

        console.log("error :>> ", error);
        return this.router.parseUrl(`/notfound`);
      }),
      catchError((error) => {
        this.spinnerService.hide();

        return throwError(error);
      })
    );
  }

  private validateOrder(order) {
    if (!order.orders || order.orders.length === 0) {
      console.log("missingRequiredOrderInfo... ");
      return false;
    }

    const o = order.orders[0];
    if (
      !o.orderLines ||
      o.orderLines.length === 0 ||
      o.orderLines.filter((x) => !x.itemName || x.returnableQuantity < 1).length > 0
    ) {
      console.log("missingRequiredOrderInfo... ");
      return false;
    }

    return true;
  }
}
